export default {
  paper: {
    minHeight: 'calc(100vh - 270px)',
    marginBottom: '20px'
  }
}
